export default {"src":"/_next/static/media/ecommerceLogo5.1a9b5d31.svg","height":36,"width":145,"blurWidth":0,"blurHeight":0};